import { App, Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import '../Account.css';

type DepositAddressCardProps = {
    address: string;
    qrPayload: string;
};

function DepositAddressCard({ address, qrPayload }: DepositAddressCardProps) {
    const { t } = useTranslation('account');
    const { message } = App.useApp();

    const onCopy = async () => {
        try {
            await navigator.clipboard.writeText(address);
            message.success(t('messages.addressCopied'));
        } catch {
            message.error(t('messages.copyAddressFailed'));
        }
    };

    return (
        <section className="panel account-deposit" aria-label={t('deposit.title')}>
            <div className="section-head">
                <h2>{t('deposit.title')}</h2>
            </div>

            <div className="account-deposit__body">
                {qrPayload ? (
                    <div className="account-deposit__qr">
                        <QRCodeSVG
                            value={qrPayload}
                            size={120}
                            marginSize={2}
                            bgColor="#eaf5fd"
                            fgColor="#081321"
                            level="M"
                            title={t('deposit.qrTitle')}
                        />
                    </div>
                ) : null}

                <div className="account-deposit__copy">
                    <span>{t('labels.address')}</span>
                    <code>{address || '—'}</code>
                    <Button
                        icon={<CopyOutlined />}
                        onClick={onCopy}
                        disabled={!address}
                    >
                        {t('actions.copyAddress')}
                    </Button>
                </div>
            </div>
        </section>
    );
}

export default DepositAddressCard;
